import axios from "axios";

const instance = axios.create({
    baseURL: 'https://backend.wasly.net/api',
    timeout: 95000,
    headers: {
        'Accept': 'text/html',
        // 'ApiKey': '3cb9b615e32d92aa5ba3ef9f26f5285fc51cf2420c299d6157d739dc36c2b034',

    }
});

const instanceForPut = axios.create({
    baseURL: 'https://backend.wasly.net/api',
    timeout: 95000,
    headers: {
        'X-Custom-Header': 'foobar',
        'Content-Type': 'application/json',
        // 'Accept': 'text/html',
        // 'ApiKey': '3cb9b615e32d92aa5ba3ef9f26f5285fc51cf2420c299d6157d739dc36c2b034',

    }
});

instance.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

instanceForPut.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

const handleResponseError = (error) => {
    if (error.response && (error.response.status === 403 || error.response.status === 401 )) {
        window.location.href = "/login";
    }
    return Promise.reject(error);
};

instance.interceptors.response.use(
    (response) => response,
    (error) => handleResponseError(error)
);

instanceForPut.interceptors.response.use(
    (response) => response,
    (error) => handleResponseError(error)
);

export const Helper = {
    Get: async (url) => {
        return instance.get(url).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    },
    Get_Abort: async ({ url, data = null, signal }) => {
        return instance.get(url, {
            params: data || {},
            signal: signal
        }).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    },
    Post: async ({ url, data = null }) => {
        return instance.post(url, data).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    },
    Put: async ({ url, data = null }) => {
        // data = { ...data, _method: 'PUT' };
        return instanceForPut.put(url, data).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    },
    Delete: async ({ url, data = null }) => {
        return instance.delete(url, {
            data: data
        }).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem("State", serializedState);
    } catch (err) {
        console.error("Could not save state", err);
    }
};

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem("State");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.error("Could not load state", err);
        return undefined;
    }
};
